import { BASE_URL } from '../helper/helper';

export const chatAPI = {
  // Create a new chat
  createChat: async (userId, chatData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/create-chat/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(chatData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error creating chat:', error);
      throw error;
    }
  },

  // Get user's chats
  getUserChats: async (userId, userModel) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/user-chats/${userId}/${userModel}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching user chats:', error);
      throw error;
    }
  },

  // Get unread chat notifications for a user
  getChatNotifications: async (userId, userModel) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/notifications/${userId}/${userModel}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching chat notifications:', error);
      throw error;
    }
  },

  // Mark all chat notifications as read
  markAllChatNotifications: async (userId, userModel) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/notifications/mark-all/${userId}/${userModel}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error marking chat notifications as read:', error);
      throw error;
    }
  },

  // Get chat details with messages
  getChatDetails: async (chatId, page = 1, limit = 50) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/chat-details/${chatId}?page=${page}&limit=${limit}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching chat details:', error);
      throw error;
    }
  },

  // Send a message (fallback for non-real-time)
  sendMessage: async (chatId, messageData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/send-message/${chatId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(messageData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  },

  // Add participants to chat
  addParticipants: async (chatId, participantsData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/add-participants/${chatId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(participantsData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error adding participants:', error);
      throw error;
    }
  },

  // Remove participant from chat
  removeParticipant: async (chatId, participantId, removalData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/remove-participant/${chatId}/${participantId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(removalData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error removing participant:', error);
      throw error;
    }
  },

  // Mark messages as read
  markMessagesAsRead: async (chatId, userData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/mark-read/${chatId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error marking messages as read:', error);
      throw error;
    }
  },

  // Get unread count
  getUnreadCount: async (userId, userModel) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/unread-count/${userId}/${userModel}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  },

  // Get all users for adding to chat
  getAllUsers: async (requesterModel) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/all-users?requester_model=${requesterModel}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  // Delete chat
  deleteChat: async (chatId, userData) => {
    try {
      const response = await fetch(`${BASE_URL}/api/chat/delete-chat/${chatId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });
      return await response.json();
    } catch (error) {
      console.error('Error deleting chat:', error);
      throw error;
    }
  }
};
